import React from "react";
import "./CustomCard.scss"; // Optional: Add CSS styles here.
import { Card, Space, Typography } from "antd";

const { Text, Title } = Typography


interface CardProps {
    icon: React.ReactNode; // Pass a path to the icon or a component
    title: string;
    subtitle: string;
    value: string | number;
    bgColor?: string; // Optional for custom background colors
}

const CustomCard: React.FC<CardProps> = ({
    icon,
    title,
    subtitle,
    value,
    bgColor = "#fff",
}) => {
    return (
        <Card className="custom-card-box">
            <Space direction="vertical" size={[20, 20]}>
                <Space direction="horizontal">
                    {icon}
                    <Text>{title}</Text>
                    <Text type="secondary">{subtitle}</Text>
                </Space>
                <Space>
                    <Title level={4}>{value}</Title>
                </Space>
            </Space>
        </Card>
    );
};

export default CustomCard;